import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './Legal.css'

export default function Privacy() {
  useEffect(() => { document.title = 'Privacy Policy — CommitHQ' }, [])

  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <Link to="/">&#8592; Back to CommitHQ</Link>
      </nav>
      <div className="legal-inner">
        <h1>Privacy Policy</h1>
        <p className="legal-date">Last updated: April 8, 2025</p>

        <p>
          CommitHQ ("we", "us", or "our") is committed to protecting your
          privacy. This policy explains what information we collect, how we use
          it, and the choices you have.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We collect information you provide directly, including:</p>
        <ul>
          <li>Account details (email address, password)</li>
          <li>Athlete profile information (name, grad year, position, stats, highlights)</li>
          <li>School pipeline data (schools added, statuses, notes)</li>
          <li>Location information used to calculate distances (ZIP code)</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use the information to:</p>
        <ul>
          <li>Provide and improve the CommitHQ service</li>
          <li>Display your public athlete profile when you share the link</li>
          <li>Send transactional emails (e.g., account confirmation)</li>
          <li>Respond to your support requests</li>
        </ul>

        <h2>3. Data Storage</h2>
        <p>
          Your data is stored securely via Supabase, which uses industry-standard
          encryption at rest and in transit. We do not sell your personal
          information to third parties.
        </p>

        <h2>4. Public Athlete Profiles</h2>
        <p>
          If you create a public athlete profile, the information on that profile
          is accessible to anyone with the link. You control what information
          appears on your profile and can update it at any time.
        </p>

        <h2>5. Cookies</h2>
        <p>
          We use cookies and local storage to maintain your session. No
          third-party advertising cookies are used.
        </p>

        <h2>6. Your Rights</h2>
        <p>You may:</p>
        <ul>
          <li>Access and update your account information at any time via Settings</li>
          <li>Request deletion of your account and associated data by emailing us</li>
        </ul>

        <h2>7. Children's Privacy</h2>
        <p>
          CommitHQ is intended for use by families, including those with minor
          athletes. Parents or guardians are responsible for supervising their
          child's use of the platform and for the information they submit on
          behalf of a minor.
        </p>

        <h2>8. Changes to This Policy</h2>
        <p>
          We may update this policy from time to time. We will notify you of
          significant changes via email or a notice on the site.
        </p>

        <h2>9. Contact</h2>
        <p>
          Questions about this policy? Email us at{' '}
          <a href="mailto:support@commithq.com">support@commithq.com</a>.
        </p>
      </div>
    </div>
  )
}
